<template>
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 84.26 74.42">
    <defs></defs>
    <title>BPR</title>
    <text class="cls-1" transform="translate(19.9 33.22)">
      <tspan class="cls-2">B</tspan>
      <tspan x="14.49" y="0">PR</tspan>
    </text>
    <text class="cls-3" transform="translate(15.58 51.61)">
      C
      <tspan class="cls-4" x="7.6" y="0">O</tspan>
      <tspan x="16.38" y="0">M</tspan>
    </text>
    <text class="cls-3" transform="translate(48.04 51.61)">CA</text>
    <path class="cls-5" d="M11.45,12.82v49H70.62v-49Zm56.71,3v20H13.92v-20Zm-54.24,23H43.3v20H13.92Zm31.85,20v-20H68.16v20Z" />
  </svg>

  <!-- <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 84.26 74.42"
  >
    <title>BPR</title>
    <text
      style="
        font-size: 16px;
        font-family: GothamRounded-Bold, Gotham Rounded;
        font-weight: 700;
        letter-spacing: 0em;
        fill: #e5502c;
      "
      transform="translate(25.17 30.88)"
    >
      B
      <tspan style="letter-spacing: 0em" x="10.88" y="0">PR</tspan>
    </text>
    <path
      style="fill: #e5502c"
      d="M5,12.82v49H77v-49Zm69,3v20H8v-20Zm-66,23H41v20H8Zm36,20v-20H74v20Z"
    />
    <text
      style="
        font-size: 10px;
        font-family: GothamRounded-Book, Gotham Rounded;
        fill: #e5502c;
      "
      transform="translate(10.89 51.82)"
    >
      C
      <tspan style="letter-spacing: 0em" x="8.12" y="0">O</tspan>
      <tspan x="17.49" y="0">M</tspan>
    </text>
    <text
      style="
        font-size: 11px;
        font-family: GothamRounded-Book, Gotham Rounded;
        fill: #e5502c;
      "
      transform="translate(50.62 51.82)"
    >
      CA
    </text>
  </svg> -->
</template>

<script>
  export default {};
</script>

<style scoped>
  .cls-1 {
    font-size: 19.98px;
    font-family:
      GothamRounded-Bold,
      Gotham Rounded;
    font-weight: 700;
  }
  .cls-1,
  .cls-3,
  .cls-5 {
    fill: #e5502c;
  }
  .cls-2 {
    letter-spacing: 0em;
  }
  .cls-3 {
    font-size: 10.3px;
    font-family:
      GothamRounded-Book,
      Gotham Rounded;
  }
  .cls-4 {
    letter-spacing: 0em;
  }
  .cls-5 {
    stroke: #e5502c;
    stroke-miterlimit: 10;
    stroke-width: 1.5px;
  }
</style>